import {
  DeleteKEKOfferFromSystem,
  DeleteKEKOfferFromSystemVariables,
} from "_graphql/mutation/kek/__generated__/DeleteKEKOfferFromSystem";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { deleteOfferFromSystem } from "_graphql/kek/mutation/index.kek";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";
import { wrapClick } from "utils";

export default function RemoveKEKContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    DeleteKEKOfferFromSystem,
    DeleteKEKOfferFromSystemVariables
  >(deleteOfferFromSystem, {
    refetchQueries: ["KEKOffers"],
  });

  const form = useFormik({
    initialValues: {
      reason: "",
    },
    onSubmit: async (values) => {
      await remove({
        variables: {
          offerId: searchParams?.id || "",
          reason: values.reason,
        },
      }).then(({ data }) => {
        if (data?.deleteOfferFromSystem) {
          toast.success("Offer Cancelled Successfully");
          refetch?.();
          setOpen?.(false);
        } else {
          toast.error("Could not cancel offer");
        }
      });
    },
  });

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Cancel Offer"
      cancelText="No, Don't Cancel Offer"
      description="This action would completely cancel offer details from system"
      reason="Reason"
      form={form}
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Cancelling Offer..." : "Cancel Offer"}
          </button>
        </>
      )}
    />
  );
}
